import { State } from '../state'
import gdcConverter from '@gd/currency-converter'
import { ERROR_CODES } from '@/model/ErrorCodes'
import { Commit } from 'vuex'

export interface PrizeStage {
  from: number
  to: number
  prize: string
}

export interface WinningDistribution {
  zoneId: string
  name: string
  numberOfWinners: string
  totalWin: string
  stages: Array<PrizeStage>
}

export interface WinningDistributionState {
  current: WinningDistribution
}

const state: WinningDistributionState = {
  current: {
    zoneId: '',
    name: '',
    numberOfWinners: '',
    totalWin: '',
    stages: [],
  },
}

export const mutations = {
  storeWinningDistribution(state: WinningDistributionState, data: WinningDistribution) {
    state.current = data
  },
}

export const actions = {
  fetchWinningDistributionById({ commit }: { commit: Commit }, tournamentId: string) {
    return new Promise((res: (value?: unknown) => void, rej: (reason?: unknown) => void) => {
      fetch(`${process.env.VUE_APP_REST_URL}winningDistribution/${tournamentId}`, {
        credentials: 'same-origin',
        cache: 'no-cache',
      })
        .then((res) => {
          if (res.status >= 400) {
            commit('error', { id: 'fetchWinningDistributionById', responseStatus: res.status }, { root: true })
            throw { errorCode: res.status === 401 ? ERROR_CODES.UNAUTHORIZED : ERROR_CODES.UNKNOWN }
          }
          return res.json()
        })
        .then((data: WinningDistribution) => {
          commit('storeWinningDistribution', data)
          res()
        })
        .catch((err: Error) => {
          rej(err)
        })
    })
  },
}

export const getters = {
  stages(state: WinningDistributionState, getters: any, rootState: State) {
    return state.current.stages.map((stage) => {
      // copy object - otherwise it's a storage mutation
      const uiStage = { ...stage }
      uiStage.prize = gdcConverter(stage.prize, { gdc: rootState.user.currency })
      return uiStage
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
